define(
    'viewmodels/shared',[
        "viewmodels/ViewModel",
        "services/config",
        "plugins/router",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (ViewModel, config, router, documentsService, i19n) {

        var vm = new ViewModel(
        {
            i19n: i19n,
            linkId: '',
            subject: ko.observable(),
            title: ko.observable(),
            message: ko.observable(),
            documents: ko.observableArray([]),
            expiry: ko.observable(),
            isExpired: ko.observable(false),
            footer: ko.observable('')
        });

        vm.activate = function (ctx) {
            vm.linkId = ctx.substring(3, ctx.length);

            return loadData(vm.linkId);
        };
        vm.attached = function () {
        };
        vm.explore = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };
        vm.clickHelp = function () {
            window.open('http://help.fileplan.com');
        };
        vm.clickDownload = function (data) {
            window.location = getUrl("documentshares/instancedocument/" + config.instanceCode + "/", data.link);

            return false;
        };

        return vm;

        function loadData(id) {
            var d = $.Deferred();

            documentsService.actions
            .getSharedMessage(id)
            .done(function (data) {
                var docs = _.map(data.documentShareDocumentLinks, function (itm) {
                    return {
                        id: itm.docIdVersion,
                        link: itm.documentShareDocumentLinkIdString,
                        title: itm.documentTitle,
                        ext: itm.extension
                    };
                });

                var exp = data.expiryDate !== null ? moment(data.expiryDate).format("D MMMM YYYY h:mm a") : null;
                var isExpired = false;

                if (exp !== null) {
                    var now = moment();
                    var before = moment(exp);
                    //var before = moment("2014-08-31T00:00:00.0000+10:00");

                    isExpired = moment(before).isBefore(now);
                }                    

                vm.subject(data.subject);
                vm.title(data.shareDisplayTitle);
                vm.message(data.message);
                vm.documents(docs);
                vm.expiry(exp);
                vm.isExpired(isExpired);
                vm.footer(data.footer);
                
                d.resolve(true);
            })
            .fail(function (e) {
                e.stopPropagation = true;

                vm.isExpired(true);
                    
                d.resolve(false);
            });

            return d.promise();
        }
        function getUrl(action, id) {
            return config.webApiUrl + action + id;
        }
    }
);
